var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { Subscribe } from '@ngx-reactive/decorator';
import { PrismClass } from './prism.class';
import { PrismService } from './prism.service';
let PrismComponent = class PrismComponent extends PrismClass {
    constructor(prismService) {
        super(prismService);
        this.prismService = prismService;
    }
    ngOnInit() {
        this.code$$$ = this.code$.subscribe({
            next: (code) => {
                if (this.codeElementRef) {
                    if (this.change === true) {
                        this.codeElementRef.nativeElement.innerHTML = code;
                        this.prismService.highlightElement(this.codeElementRef);
                        this.change = false;
                    }
                }
            }
        });
        this.language$$$ = this.language$.subscribe({
            next: (language) => {
                if (this.codeElementRef) {
                    if (this.change === true) {
                        this.prismService.highlightElement(this.codeElementRef);
                        this.change = false;
                    }
                }
            }
        });
    }
    ngAfterViewInit() {
        this.prismService.highlightElement(this.codeElementRef);
    }
    ngOnChanges(changes) {
        this.onChanges(['code', 'language'], changes);
    }
};
PrismComponent.decorators = [
    { type: Component, args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                providers: [PrismService],
                selector: 'prism-highlight',
                templateUrl: './prism.component.html'
            },] },
];
PrismComponent.ctorParameters = () => [
    { type: PrismService, },
];
PrismComponent = __decorate([
    Subscribe(['code', 'language']),
    __metadata("design:paramtypes", [PrismService])
], PrismComponent);
export { PrismComponent };
//# sourceMappingURL=prism.component.js.map